<template>
  <div class="card-store">
    <div
      class="card-store__image"
      v-if="!listView"
    >
      <img :src="'/media/wysiwyg/maerkte/' + store.pickup_location_code + '.jpg'">
    </div>

    <div class="card-store__content">
      <h4>{{ store.name }}</h4>
      <div v-if="!listView" class="card-store__details">
        <address>
          {{ store.street }}<br>
          {{ store.country_id }}-{{ store.postcode }} {{ store.city }}<br>
          <div class="card-store__phone">
            Tel. {{ store.phone }}<br>
            Fax. {{ store.fax }}
          </div>
        </address>

        <div class="description">
          <div v-html="store.description" />
        </div>
      </div>

      <span
        v-if="!listView"
        :to="localizedRoute(`/store/${store.pickup_location_code}`)"
        class="btn btn-xs btn-arrow arrow-right-dark"
      />
    </div>
  </div>
</template>

<script>

export default {
  props: {
    store: {
      type: Object,
      default: () => {
        return {}
      }
    },
    listView: {
      type: Boolean,
      default: false,
      required: false
    }
  }
}
</script>
